<template>
  <div ref="myEcharts" :style="{ height, width }"></div>
</template>
<script>
import { ref, onMounted } from "vue";
import * as echarts from "echarts";
export default {
  name: "baseBar",
  props: {
    width: {
      type: String,
      default: "100%",
    },
    height: {
      type: String,
      default: "100%",
    },
    left2Data: {
      type: Object,
      default: () => {},
    }
  },
  setup(props) {
    // console.log(props);
    const myEcharts = ref(null);
    const chart = new InitChart(props, myEcharts);
    onMounted(() => {
      // console.log(props)
      chart.init(props.left2Data,props.name,props.color);
      
    });
    return {
      myEcharts,
    };
  },
};
class InitChart {
  constructor(props, myEcharts) {
    this.props = props;
    this.myEcharts = myEcharts;
    this.state = {
      chart: null,
    };
  }

  init() {
    this.state.chart && this.destory();
    this.state.chart = echarts.init(this.myEcharts.value);
    var legendData = ['车间A', '车间B']; //图例
    var indicator = [{
            text: '数据一',
            max: 30,
        },
        {
            text: '数据二',
            max: 30
        },
        {
            text: '数据三',
            max: 30
        },
        {
            text: '数据四',
            max: 30,
            //  axisLabel: {show: true, textStyle: {fontSize: 18, color: '#333'}}
        },
        {
            text: '数据四',
            max: 30
        }    
    ];
var dataArr = [
    // {
    //     value: [20, 12, 17 ,18, 10],
    //     name: legendData[0],
    //     itemStyle: {
    //         normal: {
    //             lineStyle: {
    //                 color: '#4A99FF',
    //                 // shadowColor: '#4A99FF',
    //                 // shadowBlur: 10,
                    
    //             },
    //             shadowColor: '#4A99FF',
    //             shadowBlur: 10,
    //         },
    //     },
    //     areaStyle: {
    //         normal: { // 单项区域填充样式
    //             color: {
    //                 type: 'linear',
    //                 x: 0, //右
    //                 y: 0, //下
    //                 x2: 1, //左
    //                 y2: 1, //上
    //                 colorStops: [{
    //                     offset: 0,
    //                     color: '#5DFFD4'
    //                 }, {
    //                     offset: 0.5,
    //                     color: 'rgba(0,0,0,0)'
    //                 }, {
    //                     offset: 1,
    //                     color: '#5DFFD4'
    //                 }],
    //                 globalCoord: false
    //             },
    //             opacity: 1 // 区域透明度
    //         }
    //     }
    // },
    {
        value: [18, 15, 14, 10, 16],
        name: legendData[1],
        itemStyle: {
            normal: {
                lineStyle: {
                    color: '#07B186',
                    // shadowColor: '#4BFFFC',
                    // shadowBlur: 10,
                },
                shadowColor: '#4BFFFC',
                shadowBlur: 10,
            },
        },
         areaStyle: {
            normal: { // 单项区域填充样式
                color: {
                    type: 'linear',
                    x: 0, //右
                    y: 0, //下
                    x2: 1, //左
                    y2: 1, //上
                    colorStops: [{
                        offset: 0,
                        color: '#07B186'
                    }, {
                        offset: 0.5,
                        color: 'rgba(0,0,0,0)'
                    }, {
                        offset: 1,
                        color: '#07B186'
                    }],
                    globalCoord: false
                },
                opacity: 1 // 区域透明度
            }
        }
    }
];
var colorArr = ['#07B186', '#4BFFFC']; //颜色

    this.state.chart.setOption({
        color: colorArr,
        // legend: {
        //     orient:'vertical',
        //     icon: 'circle', //图例形状
        //     data: legendData,
        //     bottom:'center',
        //     right:40,
        //     itemWidth: 12, // 图例标记的图形宽度。[ default: 25 ]
        //     itemHeight: 12, // 图例标记的图形高度。[ default: 14 ]
        //     itemGap: 21, // 图例每项之间的间隔。[ default: 10 ]横向布局时为水平间隔，纵向布局时为纵向间隔。
        //     textStyle: {
        //         fontSize: 14,
        //         color: '#00E4FF',
        //     },
        // },
    radar: {
        // shape: 'circle',
        name: {
            textStyle: {
                color: '#BAFFDE',
                fontSize: 12,
                fontWeight:"bold"
            },
        },
        indicator: indicator,
        splitArea: { // 坐标轴在 grid 区域中的分隔区域，默认不显示。
            show: true,
            areaStyle: { // 分隔区域的样式设置。
                color: ['rgba(255,255,255,0)', 'rgba(255,255,255,0)'], // 分隔区域颜色。分隔区域会按数组中颜色的顺序依次循环设置颜色。默认是一个深浅的间隔色。
            }
        },
        axisLine: { //指向外圈文本的分隔线样式
            lineStyle: {
                color: '#0B4143',
                type:"dashed"
            }
        },
        splitLine: {
            lineStyle: {
                color: '#0B4143', // 分隔线颜色
                width: 1, // 分隔线线宽
            }
        },
    },
    series: [{
        type: 'radar',
        symbolSize: 6,
        // symbol: 'angle',
        data: dataArr
    }]
    });
    window.addEventListener("resize", () => {
      this.state.chart.resize();
    });
  }

  destory() {
    this.state.chart.dispose();
    window.removeEventListener("resize", () => {
      console.log("事件移除");
    });
  }
}
</script>
<style lang="less"></style>
